import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-add-physicians-dialog',
  templateUrl: './add-physicians-dialog.component.html',
  styleUrls: ['./add-physicians-dialog.component.scss']
})
export class AddPhysiciansDialogComponent implements OnInit {
  physicianName: string = "";
  addPracticeForm: FormGroup;
  practitionersList = [
    { id: 1, practitionerName: "Lisa", practitionerSpeciality: "Family Medicine", practitionerImg: "./assets/images/prac1.png" },
    { id: 2, practitionerName: "Ramon", practitionerSpeciality: "Pediatrics", practitionerImg: "./assets/images/prac2.jfif" },
    {
      id: 3, practitionerName: "Jess William", practitionerSpeciality: "Orthopedic surgery of spine", practitionerImg: "./assets/images/prac3.jfif" },
    { id: 4, practitionerName: "Samantha Gibson", practitionerSpeciality: "Orthopedic", practitionerImg: "./assets/images/prac4.png" },
    { id: 5, practitionerName: "Sara Jame White", practitionerSpeciality: "Family Medicine", practitionerImg: "./assets/images/prac5.png" },
    { id: 6, practitionerName: "Steve Jobs", practitionerSpeciality: "Orthopedic surgery of spine", practitionerImg: "./assets/images/prac6.jfif" }
  ];

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
  }
  initializePracticeData() {
    this.addPracticeForm = this.fb.group({
     
    });
  }
}
